import React from "react";
 
import "./css/Menu.css";
import MenuList from "./MenuList";

const Menu = () => {

  return (
       <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
        <MenuList />
      </aside>
   );
};

// Memoized: Layout (and thus the sidebar) is rendered INSIDE every page, so a
// page that re-renders frequently — e.g. the wall detail page's per-second RTDB
// telemetry — would otherwise re-render the whole sidebar on every tick. Menu
// takes no props, so memo blocks those parent-driven re-renders entirely while
// still updating on its own internal hooks (route, redux). Prevents the sidebar
// from churning mid-click and dropping navigation clicks.
export default React.memo(Menu);
